import { render, staticRenderFns } from "./PainelPublicoApresentacao.vue?vue&type=template&id=9f120888&scoped=true"
import script from "./PainelPublicoApresentacao.vue?vue&type=script&lang=js"
export * from "./PainelPublicoApresentacao.vue?vue&type=script&lang=js"
import style0 from "./PainelPublicoApresentacao.vue?vue&type=style&index=0&id=9f120888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f120888",
  null
  
)

export default component.exports